<template>
    <router-view v-if="previewImage"/>
    <div v-else class="wrap preview tbl" :class="{parents: $isIamschoolParent}">
        <!-- [D] HEADER -->
        <div class="header tbl_row">
            <button type="button" class="btn_back" @click="closePreviewFile"><span
                class="sp">{{ $t('PreviewFile_back') }}</span></button>
            <span class="tit">
                <span class="fe-filename-container">
                    <span class="fe-filename">{{ fileName }}</span>
                    <span class="fe-filename-ext">.{{ ext }}</span>
                </span>
            </span>
        </div>
        <div class="tbl_row">
            <div class="tbl_cell">
                <button type="button" class="btn_prev" v-if="document.attachments.length" v-show="nowOrderNo !== 0" @click="onClickPrev"><span class="sp">{{$t('PreviewFile_prev')}}</span></button>
                <!-- [D] swipe area -->
                <div class="swipe_area" ref="zoom">
                    <span v-if="!document.attachments.length" style="width: 100%;display: inline-block;text-align: center;color: white;font-size: 16px;">{{$t('PreviewFile_noPrepare')}}</span>
                    <span class="img" v-for="attachment in document.attachments" v-show="attachment.orderNo === nowOrderNo"><img :src="attachment.image.url" @click="onClickPreviewImage(nowOrderNo)"></span>
                </div>
                <!-- //[D] swipe area -->
                <button type="button" class="btn_next" v-if="document.attachments.length" v-show="nowOrderNo !== document.attachments.length - 1" @click="onClickNext"><span class="sp">{{$t('PreviewFile_next')}}</span></button>
            </div>
        </div>
        <div class="btn_area tbl_row">
            <a :href=document.downloadUrlForExternal class="btn">{{$t('PreviewFile_download')}}</a>
        </div>
    </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import {schema} from '@/common/utils/webview.js';
import {SET_FILE_NOW_ORDER_NO} from '@/common/store/modules/enrolment/response.js';
import PinchZoom from "pinch-zoom-js";
import {showToast} from "@/common/utils/simpleToast.js";

const {mapActions} = createNamespacedHelpers('response');

export default {
    name: "FilePreview",

    props: {
        document: {
            type: Object,
            required: true,
            },
            type: {
                type: String,
                required: true
            }
        },

        metaInfo() {
            const title = this.$t('common_previewFile');
            return {title}
        },

        data() {
            return {
                nowOrderNo: 0,
                previewImage: false
            };
        },

        watch: {
            nowOrderNo(newValue) {
                this.$nextTick(() => {
                    this.zoom.zoomFactor = 1;
                    window.dispatchEvent(new Event('resize'));
                });
            },

            '$route'() {
                this.setPreviewImage();
            }
        },

        computed: {
            isWebView() {
                return this.$route.query.hasOwnProperty('isMasking');
            },

            splitFileName() {
                return this.document.fileName.split('.');
            },

            fileName() {
                return this.splitFileName.slice(0, this.splitFileName.length - 1).join();
            },

            ext() {
                return this.splitFileName[this.splitFileName.length - 1];
            }
        },

        methods: {
            ...mapActions({
               setFileNowOrderNo: SET_FILE_NOW_ORDER_NO,
            }),

            closePreviewFile() {
                this.setFileNowOrderNo({nowOrderNo: 0});
                this.$router.go(-1);
            },
            onClickPrev() {
                this.nowOrderNo -= 1;
                showToast(`${this.nowOrderNo + 1}/${this.document.attachments.length}`);
            },
            onClickNext() {
                this.nowOrderNo += 1;
                showToast(`${this.nowOrderNo + 1}/${this.document.attachments.length}`);
            },
            onClickPreviewImage(orderNo) {
                if (this.isWebView) {
                    schema('webview', `article/preview/multimedia?index=${orderNo}`);
                    return;
                }
                this.$router.push({
                    name: `${this.type}ResponseFileImage`,
                    query: {
                        ...this.$route.query,
                        imageOrder: orderNo,
                    }
                });
            },
            setPreviewImage() {
                if (this.$route.matched.some(m => m.name && m.name.match(/ResponseFileImage$/))) {
                    this.previewImage = true;
                } else {
                    this.previewImage = false;
                }
            },

            onChangeFileImageOrder({order}) {
                this.nowOrderNo = order;
            },

            startPinchZoom() {
                if (!this.previewImage && this.document.attachments.length && !this.$refs.zoom.pinch) {
                    this.$nextTick(() => {
                        this.prev = this.$refs.zoom;
                        this.zoom = new PinchZoom(this.$refs.zoom, {
                            draggableUnzoomed: false
                        });

                        this.$refs.zoom.pinch = true;
                    });
                }
            }
        },

        updated() {
            this.startPinchZoom();
        },

        mounted() {
            this.startPinchZoom();
        },

        created() {
            this.setPreviewImage();

            if (this.document.attachments.length) {
                showToast(`1/${this.document.attachments.length}`);
            }

            this.$eventBus.$on('changeFileImageOrder', this.onChangeFileImageOrder);
        },

        beforeDestroy() {
            this.$eventBus.$off('changeFileImageOrder', this.onChangeFileImageOrder);
        }
    }
</script>
